import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { replaceUrlParam } from "../../common/utils";

import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import CustomTable from "../../common/CustomTable";
import {
  fetchProducts,
  fetchProductByID,
  selectProducts,
  fetchMoreProducts,
  getFullList,
} from "./productsSlice";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import {
  fetchBrands,
  selectBrands,
  getFullList as getFullBrandsList,
} from "../brands/brandsSlice";
import {
  fetchSuppliers,
  selectSuppliers,
  getFullList as getFullSuppliersList,
} from "../suppliers/suppliersSlice";
import {
  fetchCategoriesTree,
  fetchCategories,
  selectCategories,
} from "../categories/categoriesSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function ProductListUpdate(props) {
  const history = useHistory();
  const location = useLocation();

  const {} = useSelector(selectProducts);

  const { lastQuery, loading, productList, headCells, productsAmount } =
    useSelector(selectProducts);
  const { brandsList, brandsAmount } = useSelector(selectBrands);

  const { suppliersList, suppliersAmount } = useSelector(selectSuppliers);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let jwtToken = localStorage.getItem("coreToken");
  let coreUser = localStorage.getItem("coreUser");
  const { categoriesList } = useSelector(selectCategories);

  const dispatch = useDispatch();
  const classes = useStyles();
  const [productNames, setProductNames] = useState([]);
  const [productIDs, setProductIDs] = useState([]);
  // const edit = props.location.pathname.includes('edit');
  const [brandNames, setBrandNames] = useState([]);
  const [brandIDs, setBrandIDs] = useState([]);
  const [supplierIDs, setSupplierIDs] = useState([]);
  const [supplierNames, setSupplierNames] = useState([]);
  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [countryNames, setCountryNames] = useState([]);
  const [countryIDs, setCountryIDs] = useState([]);
  // const [search, setSearchTerm] = useState("");
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 23, value: "Refunded", name: "Refunded" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState("createdAt");
  const [sortDirection, setSortDirection] = useState("desc");

  const [searchTerm, setSearchTerm] = useState("");
  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");

  const [brandsReady, setBrandsReady] = useState(false);

  const countryList = [
    { id: 1, value: "Australia", name: "Australia" },
    { id: 2, value: "New Zealand", name: "New Zealand" },
  ];

  useEffect(() => {
    if (!brandsList.length) {
      dispatch(fetchBrands({ token: jwtToken, query: "" }));
    }
    if (!suppliersList.length) {
      dispatch(fetchSuppliers({ token: jwtToken, query: "" }));
    }
    if (!categoriesList.length) {
      dispatch(fetchCategoriesTree({ token: jwtToken, query: "" }));
    }
    setBrandsReady(true);
  }, [dispatch]);

  useEffect(() => {
    if (brandsAmount && brandsReady) {
      console.log("getting in here");
      setBrandsReady(false);
      dispatch(
        getFullBrandsList({
          token: jwtToken,
          offset: brandsList.length,
          query: "?limit=100",
          targetLength: brandsAmount,
        })
      );
    }
  }, [brandsList.length]);

  useEffect(() => {
    if (suppliersList.length > 1 && suppliersList.length < suppliersAmount) {
      dispatch(
        getFullSuppliersList({
          token: jwtToken,
          offset: suppliersList.length,
          query: "?limit=100",
          targetLength: suppliersAmount,
        })
      );
    }
  }, [suppliersList.length]);

  const [checked, setCategoriesChecked] = useState([]);
  const [names, setNames] = useState([]);
  const handleToggle = (e, value, name) => {
    e.stopPropagation();
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const currentNameIndex = names.indexOf(name);
    const newNames = [...names];

    if (currentNameIndex === -1) {
      newNames.push(name);
    } else {
      newNames.splice(currentNameIndex, 1);
    }
    setNames(newNames);
    setCategoriesChecked(newChecked);
  };

  const [rowList, setRowList] = useState([...headCells]);

  const handleProductsChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedProduct = productList.filter(
      (product) => product.name === event.target.value
    );
    selectedProduct && idsArr.push(selectedProduct[0].id);
    // });

    setProductNames(event.target.value);
    setProductIDs(idsArr);
  };

  const handleBrandsChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedBrand = brandsList.filter((brand) => brand.name === selected);
      selectedBrand[0] && idsArr.push(selectedBrand[0].id);
    });
    setBrandNames(event.target.value);
    setBrandIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  const handleCountryChange = (event) => {
    let idsArr = [];    

    let selectedCountry = countryList.filter(
      (country) => country.name === event.target.value
    );
    selectedCountry[0] && idsArr.push(selectedCountry[0].id);

    setCountryNames(event.target.value);
    setCountryIDs(idsArr);
  };

  const handleSupplierChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedSupplier = suppliersList.filter(
        (supplier) => supplier.name === selected
      );
      selectedSupplier[0] && idsArr.push(selectedSupplier[0].id);
    });

    setSupplierNames(event.target.value);
    setSupplierIDs(idsArr);
  };

  function getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return "";
    if (!results[2]) return "";
    return name === "query"
      ? decodeURIComponent(results[2].replace(/\+/g, " ")).split(",")
      : decodeURIComponent(results[2].replace(/\+/g, " "))
          .split(",")
          .map(Number);
  }

  const getFilterObjects = (ids, list) => {
    let objs = [];
    ids &&
      ids.forEach((id) => {
        let selectedItems = list.filter(
          (listItem) => listItem.id === Number(id)
        );
        selectedItems[0] && objs.push(selectedItems[0].name);
        // selectedItems[0] && objs.push(selectedItems);
      });

    return objs;
  };

  const getCategoryNames = (ids, list) => {
    let catNames = [];
    ids &&
      ids.forEach((id) => {
        let selectedItems = list.filter(
          (listItem) => listItem.id === Number(id)
        );
        selectedItems[0] && catNames.push(selectedItems[0].name);
      });

    return catNames;
  };

  const updateTableQueryParams = () => {
    const q = getParameterByName("query", lastQuery);
    setSearchTerm(q);
    const c = getParameterByName("categories", lastQuery);
    if (c) {
      let catNames = getCategoryNames(c, categoriesList);
      setNames(catNames);
      setCategoriesChecked(c);
    }
    const s = getParameterByName("statuses", lastQuery);
    if (s) {
      let sObj = getFilterObjects(s, statusList);
      setStatusNames(sObj);
      setStatusIDs(s);
    }
    const b = getParameterByName("brands", lastQuery);
    if (b) {
      let bObj = getFilterObjects(b, brandsList);

      setBrandNames(bObj);
      setBrandIDs(b);
    }
    const sup = getParameterByName("suppliers", lastQuery);
    if (sup) {
      let supObj = getFilterObjects(sup, suppliersList);

      setSupplierNames(supObj);
      setSupplierIDs(sup);
    }
    const cou = getParameterByName("country_id", lastQuery);
    if (cou) {
      let cObj = getFilterObjects(cou, countryList);

      setCountryNames(cObj);
      setCountryIDs(c);
    }
  };

  useEffect(() => {
    updateTableQueryParams();
  }, [location]);

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }

    let property = sortProperty;
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    searchQuery = replaceUrlParam(searchQuery, "order_by", property);

    searchQuery = replaceUrlParam(searchQuery, "sort", sortDirection);
    dispatch(
      fetchProducts({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > productList.data.length
            ? rowsPerPage
            : productList.data.length,
        query: searchQuery,
        targetLength: productsAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        productList.data.length < productsAmount &&
        productList.data.length < expectedLen
      ) {
        dispatch(
          fetchMoreProducts({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (productList.data.length == productsAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchProducts({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `${dateAfter.toISOString().substring(0, 10)},${dateBefore
        .toISOString()
        .substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `gte,${dateAfter.toISOString().substring(0, 10)}`;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    searchQuery = replaceUrlParam(searchQuery, "categories", checked.join(","));

    searchQuery = replaceUrlParam(searchQuery, "brands", brandIDs.join(","));

    if (supplierIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "suppliers",
        supplierIDs.join(",")
      );
    }
    if (countryIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "country_id",
        countryIDs.join(",")
      );
    }
    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "odate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "query", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchProducts({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setProductNames([]);
    setProductIDs([]);
    setBrandNames([]);
    setBrandIDs([]);
    setSupplierNames([]);
    setSupplierIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setCountryNames([]);
    setCountryIDs([]);
    setDateBefore("");
    setDateAfter("");
    setSearchTerm("");
    setCategoriesChecked([]);
    setSortDirection(null);
    setSortProperty(null);
    setNames([]);

    dispatch(
      fetchProducts({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const handleEditClick = (id) => {
    dispatch(
      fetchProductByID({
        token: jwtToken,
        id: id,
      })
    );

    history.push(`/products/edit/${id}`);
  };

  let content;
  const actionsHandleChange = [
    handleBrandsChange,
    handleSupplierChange,
    handleStatusChange,
    handleCountryChange,
  ];
  const actionsNames = [brandNames, supplierNames, statusNames, countryNames];
  const actionsLists = [brandsList, suppliersList, statusList, countryList];
  const selectNames = ["brand", "supplier", "status", "country"];

  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    let options = {
      timeZone: "Australia/Sydney",
    };

    content = (
      <CustomTable
        actionsLists={actionsLists}
        actionsHandleChange={actionsHandleChange}
        actionsNames={actionsNames}
        data={productList.data}
        headCells={headCells}
        cellList={cellList}
        handleSearch={handleSearch}
        handleClear={handleClear}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        handleEditClick={handleEditClick}
        checked={checked}
        names={names}
        setNames={setNames}
        handleToggle={handleToggle}
        area={"product"}
        selectNames={selectNames}
        rowList={rowList}
        setRowList={setRowList}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        productsAmount={productsAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
